export function TimeZone() {
  /* store across requests, within the object  */
  let current_timezone;
  let current_date;

  const self = this;
  const moment = window.moment;

  this.validate = function () {
    if (!current_timezone) {
      alert("timezone not set because value = " + current_timezone);
    }
  };

  this.localFormat = function (unix_ts, custom_moment_format) {
    self.validate();
    /* Add a "default parameter" which allows user to override default
     * format */
    if (typeof custom_moment_format == "undefined") {
      return (
        self.localDate(unix_ts) +
        " " +
        moment(unix_ts * 1000)
          .tz(current_timezone)
          .format("H:mm:ss")
      );
    } else {
      return moment(unix_ts * 1000)
        .tz(current_timezone)
        .format(custom_moment_format);
    }
  };

  this.localDate = function (unix_ts) {
    self.validate();

    return moment(unix_ts * 1000)
      .tz(current_timezone)
      .format("YYYY-MM-DD");
  };

  this.set = function (timezone) {
    current_timezone = timezone;
  };

  // really using this as global to pass date to other controllers.
  this.setDate = function (current_date_as_string) {
    current_date = current_date_as_string;
  };

  this.getDate = function () {
    return current_date;
  };
}
